'use strict';

const Mn = require('backbone.marionette');
const MemberModel = require('common/domain/entity/project-member');
const ProjectMemberIconView = require('common/ui/view/project/member-icon');
const ProjectMemberNameView = require('common/ui/view/project/member-name');
const Template = require('balus/ui/template/body/project/modal/member-item-edit.hbs');

module.exports = Mn.View.extend({
    model: MemberModel,
    tagName: 'li',
    className: 'list-item',
    template: Template,
    ui: {
        roleSelector: 'select.form-control.role',
    },
    triggers: {
        'click .member-remove': 'delete'
    },
    regions: {
        icon: '.list-item-icon',
        title: '.list-item-header-title',
    },

    bindings: {
        'select.role': 'role'
    },
    modelEvents: {
        'change': function() {
            this.trigger('change:member');
        }
    },

    templateContext: function() {
        const login_user = this.getOption('user');
        const user = this.model.getUser();
        const context = this.getOption('context')
        const group = context.getGroup();
        const member = group.getMembers().getMemberByUser(user);

        let group_role = null
        if (group.isMember(user)) {
            group_role = member.getRole()
        }

        return {
            role: this.model.getRole(),
            projectRoles: this.getOption('projectRoles')
                .chain()
                .filter(role => role.isSelectable(group_role))
                .map(role => {
                    return {
                        id: role.id,
                        name: role.getName()
                    }
                })
                .value(),
            isRemovable: login_user.id != user.id,
            isEditable: true
        };
    },

    onRender: function() {
        const user = this.getOption('user');
        if (user.id === this.model.id) {
            this.ui.roleSelector.attr('disabled', 'disabled');
        }
        this.showChildView('icon', new ProjectMemberIconView({
            model: this.model
        }));
        this.showChildView('title', new ProjectMemberNameView({
            model: this.model
        }));

        this.stickit();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/modal/member-item-edit.js